class BxfNumericStepperConstants {
    static STRING = {
        DEFAULT_LABEL: 'Label',
        STEPPER_ICON_UP: 'arrow-dropdown-up',
        STEPPER_ICON_DOWN: 'arrow-dropdown',
        DISABLED: 'disabled',
        READONLY: 'bxf-numeric-stepper-readonly',
        UP_ARROW_CATEGORY: 'up_arrow',
        DOWN_ARROW_CATEGORY: 'down_arrow',
        CONTAINER_CATEGORY: 'container',
        OUTER_CONTAINER: 'bxf-numeric-stepper__outer-container',
        OUTER_CONTAINER_LEFT: 'bxf-numeric-stepper__outer-container--left',
        LABEL: 'bxf-numeric-stepper__label',
        LABEL_TEXT: 'bxf-numeric-stepper__label-text',
        LABEL_TEXT_COMPACT: 'bxf-numeric-stepper__label-text--compact',
        LABEL_WITH_INSTRUCTIONAL_TEXT: 'bxf-numeric-stepper__label-text--instructional-text',
        LABEL_LEFT: 'bxf-numeric-stepper__label--left',
        LABEL_LEFT_INSTRUCTIONAL: 'bxf-numeric-stepper__label--left-instructional',
        LABEL_LEFT_INSTRUCTIONAL_SMALL: 'bxf-numeric-stepper__label--left-instructional-small',
        LABEL_LEFT_INSTRUCTIONAL_REGULAR: 'bxf-numeric-stepper__label--left-instructional-regular',
        LABEL_LEFT_INSTRUCTIONAL_ERROR: 'bxf-numeric-stepper__label--left-instructional-error',
        LABEL_LEFT_COMPACT: 'bxf-numeric-stepper__label--left-compact',
        LEFT_LABEL_VALIDATION_MESSAGE: 'bxf-numeric-stepper__label--left-val-message',
        CONTAINER: 'bxf-numeric-stepper__container',
        CONTAINER_SMALL: 'bxf-numeric-stepper__container--small',
        CONTAINER_STEPPER_WITH_ERROR: 'bxf-numeric-stepper__stepper-container--error',
        CONTAINER_STEPPER_WITH_WARNING: 'bxf-numeric-stepper__stepper-container--warning',
        INNER_CONTAINER: 'bxf-numeric-stepper__inner-container',
        CONTAINER_INPUT: 'bxf-numeric-stepper__input-container',
        CONTAINER_STEPPER: 'bxf-numeric-stepper__stepper-container',
        CONTAINER_STEPPER_SMALL: 'bxf-numeric-stepper__stepper-container--small',
        INPUT: 'bxf-numeric-stepper__input',
        INPUT_SMALL: 'bxf-numeric-stepper__input--small',
        INPUT_PREPENDED: 'bxf-numeric-stepper__input--prepended',
        INPUT_APPENDED: 'bxf-numeric-stepper__input--appended',
        CONTAINER_KEY_FOCUS: 'bxf-numeric-stepper__container--keyboard-focused',
        PREPENDED_STRING: 'bxf-numeric-stepper__prepended-string',
        APPENDED_STRING: 'bxf-numeric-stepper__appended-string',
        ICON_UP_ARROW: 'bxf-numeric-stepper__icon-up-arrow',
        ICON_UP_ARROW_SMALL: 'bxf-numeric-stepper__icon-up-arrow--small',
        ICON_UP_ARROW_ERROR: 'bxf-numeric-stepper__icon-up-arrow--error',
        ICON_UP_ARROW_WARNING: 'bxf-numeric-stepper__icon-up-arrow--warning',
        ICON_DOWN_ARROW: 'bxf-numeric-stepper__icon-down-arrow',
        ICON_DOWN_ARROW_SMALL: 'bxf-numeric-stepper__icon-down-arrow--small',
        ICON_DOWN_ARROW_ERROR: 'bxf-numeric-stepper__icon-down-arrow--error',
        ICON_DOWN_ARROW_WARNING: 'bxf-numeric-stepper__icon-down-arrow--warning',
        CONTAINER_FOCUSED: 'bxf-numeric-stepper__container--focused',
        CONTAINER_INPUT_FOCUSED: 'bxf-numeric-stepper__input--focused',
        CONTAINER_STEPPER_FOCUSED: 'bxf-numeric-stepper__stepper--focused',
        ERROR_CONTAINER_FOCUSED: 'bxf-numeric-stepper__container--error--focused',
        ERROR_CONTAINER_STEPPER_FOCUSED: 'bxf-numeric-stepper__stepper--error--focused',
        ERROR_CONTAINER_INPUT_FOCUSED: 'bxf-numeric-stepper__input--error--focused',
        WARNING_CONTAINER_FOCUSED: 'bxf-numeric-stepper__container--warning--focused',
        WARNING_CONTAINER_STEPPER_FOCUSED: 'bxf-numeric-stepper__stepper--warning--focused',
        WARNING_CONTAINER_INPUT_FOCUSED: 'bxf-numeric-stepper__input--warning--focused',
        ERROR_MESSAGE: 'bxf-numeric-stepper__message--error',
        WARNING_MESSAGE: 'bxf-numeric-stepper__message--warning',
        FOCUS_STYLE: 'bxf-numeric-stepper__focus-element',
        INSTRUCTIONAL_TEXT: 'bxf-numeric-stepper__instructional-text',
    };
    static NUMBER = {
        DEFAULT_STEP_VALUE: 1,
        STEPPER_MAX_LENGTH: 4,
        STEPPER_MAX_VALUE: 9999,
        STEPPER_MIN_VALUE: -999,
    };
}

export { BxfNumericStepperConstants as B };
